import {Component, Inject, OnInit} from '@angular/core';
import {PaymentService} from "../../../core/services/payment.service";
import {ActivatedRoute, Router} from "@angular/router";
import {TuiAlertService, TuiLoaderModule} from "@taiga-ui/core";
@Component({
  selector: 'app-card-payment-add',
  standalone: true,
  imports: [
    TuiLoaderModule
  ],
  providers: [
    PaymentService
  ],
  templateUrl: './card-payment-add.component.html',
  styleUrl: './card-payment-add.component.scss'
})
export class CardPaymentAddComponent implements OnInit {
  memberId: any
  sessionId: any
  isLoading = false;

  constructor( private paymentService: PaymentService,
               private route: ActivatedRoute,
               private router: Router,
               @Inject(TuiAlertService) private readonly alerts: TuiAlertService,) {
  }

  ngOnInit() {
    this.memberId = this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe(params => {
      this.sessionId = params['session_id'];
    });

    if (this.memberId) {
      this.initialize()
    } else if (this.sessionId) {
      this.checkSessionStatus()
    }
  }

  async initialize() {
    this.isLoading = true
   try {
     const stripe = await this.paymentService.getStripe();
     if (!stripe) {
       return;
     }
     const response = await this.paymentService.cratePaymentSession(this.memberId);
     const  clientSecret  = response.client_secret;
     const checkout = await stripe.initEmbeddedCheckout({
       clientSecret,
     });
     // Mount Checkout
     checkout.mount('#checkout');
     this.isLoading = false
   } catch (e) {
     this.isLoading = false
     this.alerts.open('<p style="color: red">Payment page can\'t open</p>',{status: 'error'}).subscribe();
   }
  }
   async checkSessionStatus() {
     this.isLoading = true
   try {
     const response = await this.paymentService.paymentSessionStatus(this.sessionId);
     if (response.status === 'open') {
       this.alerts.open('<p style="color: green">Payment unsuccessfully</p>',).subscribe();
       this.router.navigate([`member/profile`])
     } else if (response.status === 'complete') {
       this.alerts.open('<p style="color: red">Payment successfully</p>',{status: 'error'}).subscribe();
       this.router.navigate([`member/profile`])
     }
     this.isLoading = false
   } catch (e) {
     this.isLoading = false
     this.alerts.open('<p style="color: red">Paying status can\'t verify </p>',{status: 'error'}).subscribe();
     this.router.navigate([`member/profile`])
   }
  }
}
